import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import { Toaster } from "./components/ui/sonner";

import ClubGate from "./pages/ClubGate";
import Register from "./pages/Register";
import AdminLogin from "./pages/AdminLogin";
import AdminPanel from "./pages/AdminPanel";
import DashboardLayout from "./components/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Teams from "./pages/Teams";
import Players from "./pages/Players";
import Finances from "./pages/Finances";
import Settings from "./pages/Settings";
import Transfers from "./pages/Transfers";
import Employees from "./pages/Employees";
import Payslips from "./pages/Payslips";
import Calendar from "./pages/Calendar";
import Members from "./pages/Members";
import Performances from "./pages/Performances";
import MatchSheets from "./pages/MatchSheets";
import Ticketing from "./pages/Ticketing";
import PublicTicketing from "./pages/PublicTicketing";
import PaymentStatus from "./pages/PaymentStatus";
import TicketView from "./pages/TicketView";
import DocumentCenter from "./pages/DocumentCenter";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A4628]">
        <div className="w-10 h-10 border-4 border-[#FCD116] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App font-body">
      <AdminAuthProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PublicOnly><ClubGate /></PublicOnly>} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/panel" element={<AdminPanel />} />
              {/* Public ticketing routes (no auth) */}
              <Route path="/billetterie/:slug/:eventId" element={<PublicTicketing />} />
              <Route path="/billetterie/status/:orderId" element={<PaymentStatus />} />
              <Route path="/billetterie/ticket/:ticketId" element={<TicketView />} />
              {/* /status was removed for privacy — admin sees stats in /admin/panel */}
              <Route path="/status" element={<Navigate to="/admin" replace />} />
              {/* Aliases */}
              <Route path="/login" element={<Navigate to="/" replace />} />
              <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
              <Route path="/app" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="teams" element={<Teams />} />
                <Route path="players" element={<Players />} />
                <Route path="performances" element={<Performances />} />
                <Route path="match-sheets" element={<MatchSheets />} />
                <Route path="ticketing" element={<Ticketing />} />
                <Route path="transfers" element={<Transfers />} />
                <Route path="employees" element={<Employees />} />
                <Route path="payslips" element={<Payslips />} />
                <Route path="finances" element={<Finances />} />
                <Route path="calendar" element={<Calendar />} />
                <Route path="members" element={<Members />} />
                <Route path="documents" element={<DocumentCenter />} />
                <Route path="settings" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </AdminAuthProvider>
    </div>
  );
}

export default App;
